var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showViewer)?_c('CommonImageViewer',{attrs:{"on-switch":_vm.onSwitch,"on-close":() => {this.showViewer = false},"url-list":_vm.imageList}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }